/**
 * 과제 Firestore 경로에서 폴더 표시명 배열 반환
 *
 * path 예: "Report/{folderId}/Report/{reportId}" → ["Unit 1", "Lesson 3"] 형태
 */
import { DocumentData } from "firebase/firestore";

type ReadFirestoreOneDoc = (
    collectionPath: string,
    docId: string
) => Promise<{ exists: () => boolean; data: () => DocumentData | undefined }>;

export const getReportFolderPath = async (
    readFirestoreOneDoc: ReadFirestoreOneDoc,
    path: string
): Promise<string[]> => {
    const folderIdList = path.split("/").filter((item) => item !== "Report");

    if (!folderIdList.length) {
        return [];
    }

    let currentPath = "Report";
    const folderTargets = folderIdList.map((id) => {
        const collectionPath = currentPath;
        currentPath = `${currentPath}/${id}/Report`;
        return { collectionPath, id };
    });

    return Promise.all(
        folderTargets.map(({ collectionPath, id }) =>
            readFirestoreOneDoc(collectionPath, id).then((res) =>
                res.exists() ? (res.data()?.name ?? id) : id
            )
        )
    );
};
